import React, { useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import { FaBars, FaTimes } from 'react-icons/fa'; // Importing hamburger and X icons from react-icons
import styles from '../../styles/pages/gallerypage.module.css';
import PhotoGallery from './PhotoGallery';
import CreateSliderForm from '../../components/CreateSliderForm';
import UpdateSliderForm from '../../components/UpdateSliderForm';
import { useAuth } from "../../authentication/AuthContext.js";

function Gallery() {
  const [selectedGallery, setSelectedGallery] = useState('');
  const [gallerySections, setGallerySections] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [editData, setEditData] = useState(null);
  const [isCreate, setIsCreate] = useState(false);
  const [loading, setLoading] = useState(true);
  const [sidebarVisible, setSidebarVisible] = useState(false); // Sidebar visibility state
 const { isAuthenticated } = useAuth();

  // Fetch gallery sections
  const fetchGallerySections = useCallback(async () => {
    try {
      setLoading(true);
      const res = await axios.get('/api/gallery-items');

      const uniqueSections = [
        ...new Map(res.data.map(item => [item.section, item])).values()
      ];

      const formattedSections = uniqueSections.map(item => ({
        text: item.section,
        link: item.section,
        data: item,
      }));

      setGallerySections(formattedSections);

      if (!selectedGallery && formattedSections.length > 0) {
        setSelectedGallery(formattedSections[0].link);
      }
    } catch (err) {
      console.error('Error fetching gallery sections:', err);
    } finally {
      setLoading(false);
    }
  }, [selectedGallery]);

  useEffect(() => {
    fetchGallerySections();
  }, [fetchGallerySections]);

  const handleGallerySelect = (link) => {
    if (selectedGallery !== link) {
      setSelectedGallery(link);
      setEditData(null);
    }
  };

  const handleEditClick = (sectionData) => {
    setEditData({ _id: sectionData._id, ...sectionData });
    setIsCreate(false);
    setModalOpen(true);
  };

  const handleCreateClick = () => {
    setEditData(null);
    setIsCreate(true);
    setModalOpen(true);
  };

  // Toggle Sidebar visibility
  const toggleSidebar = () => {
    setSidebarVisible(!sidebarVisible);
  };

  return (
    <div style={{ display: 'flex', height: '100vh', position: 'relative' }}>
      {/* Sidebar */}
      <div
       className={`${styles.sidebar} ${sidebarVisible ? styles.showSidebar : ''}`}
    
      >
        <h3 style={{ marginBottom: '20px' }}>Gallery Sections</h3>

        {loading ? (
          <p>Loading gallery sections...</p>
        ) : (
          gallerySections.map((item, index) => (
            <div
              key={index}
              onClick={() => handleGallerySelect(item.link)}
              style={{
                marginBottom: '10px',
                cursor: 'pointer',
                borderRadius: '6px',
                padding: '10px 12px',
                backgroundColor: selectedGallery === item.link ? '#343a40' : '#ffffff',
                color: selectedGallery === item.link ? '#ffffff' : '#333',
                fontWeight: selectedGallery === item.link ? 'bold' : 'normal',
                border: selectedGallery === item.link ? '2px solid #007bff' : '1px solid #ccc',
                transition: 'all 0.2s ease-in-out',
              }}
            >
              {item.text}
               {isAuthenticated && (
              <button
                onClick={() => handleEditClick(item.data)}
                style={{
                  marginLeft: '10px',
                  padding: '5px 10px',
                  background: '#007bff',
                  color: '#fff',
                  border: 'none',
                  cursor: 'pointer',
                  borderRadius: '4px',
                }}
              >
                Edit
              </button>
                )}
            </div>
          ))
        )}

        {isAuthenticated && (
        <button
          onClick={handleCreateClick}
          style={{
            marginTop: '20px',
            padding: '10px',
            background: '#28a745',
            color: '#fff',
            border: 'none',
            cursor: 'pointer',
            borderRadius: '4px',
          }}
        >
          Create New Slider
        </button>
        )}
      </div>

      {/* Sidebar Toggle Button (Hamburger for Small Devices) */}
      <button
        onClick={toggleSidebar}
        className={styles.toggleButton}
      
      >
        <FaBars size={24} color="white" />
      </button>

      {/* Close Button (X) to close Sidebar */}
      <button
        onClick={toggleSidebar}
        className={styles.closeButton}
        style={{
          display: sidebarVisible ? 'block' : 'none', // Show when sidebar is visible
        }}
      >
        <FaTimes size={24} color="white" />
      </button>

      {/* Main Content - Gallery */}
      <div
        className="body"
        style={{
          flexGrow: 1,
          overflow: 'auto',
          padding: '20px',
          backgroundColor: 'white',
        }}
      >
        <div className={styles.gallery}>
          {selectedGallery && <PhotoGallery section={selectedGallery} />}
        </div>
      </div>

      {/* Modal for Creating or Editing Slider */}
      {modalOpen && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000,
          }}
        >
          <div
            style={{
              background: '#fff',
              padding: '20px',
              borderRadius: '8px',
              width: '80%',
              maxWidth: '600px',
              position: 'relative',
            }}
          >
             {isAuthenticated && (
            <button
              onClick={() => setModalOpen(false)}
              style={{
                position: 'absolute',
                top: '10px',
                right: '10px',
                color: 'black',
                border: 'none',
                fontSize: '18px',
                cursor: 'pointer',
              }}
            >
              &times;
            </button>
             )}

            {isCreate ? (
               
              <CreateSliderForm
                refreshGallery={fetchGallerySections}
                closeModal={() => setModalOpen(false)}
              />
              
            ) : (
              <UpdateSliderForm
                data={editData}
                refreshGallery={fetchGallerySections}
                closeModal={() => setModalOpen(false)}
              />
            )}

            
          </div>
        </div>
      )}
    </div>
  );
}

export default Gallery;
